/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RateAlert } from './RateAlert';
import {
    RateAlertFromJSON,
    RateAlertFromJSONTyped,
    RateAlertToJSON,
    RateAlertToJSONTyped,
} from './RateAlert';

/**
 * A collection of rate alerts
 * @export
 * @interface RateAlertCollection
 */
export interface RateAlertCollection {
    /**
     * 
     * @type {Array<RateAlert>}
     * @memberof RateAlertCollection
     */
    items: Array<RateAlert>;
}

/**
 * Check if a given object implements the RateAlertCollection interface.
 */
export function instanceOfRateAlertCollection(value: object): value is RateAlertCollection {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function RateAlertCollectionFromJSON(json: any): RateAlertCollection {
    return RateAlertCollectionFromJSONTyped(json, false);
}

export function RateAlertCollectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): RateAlertCollection {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(RateAlertFromJSON)),
    };
}

export function RateAlertCollectionToJSON(json: any): RateAlertCollection {
    return RateAlertCollectionToJSONTyped(json, false);
}

export function RateAlertCollectionToJSONTyped(value?: RateAlertCollection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(RateAlertToJSON)),
    };
}

